<template>
  <div>
    <swiper-component :modules="[Navigation, Pagination, Autoplay]" :slides-per-view="1" :space-between="30"
      :navigation="{ nextEl: '.custom-next', prevEl: '.custom-prev' }" :pagination="{ clickable: true }" :autoplay="{ delay: 5000 }"
      class="mySwiper" @slideChange="updatePagination">
      <!-- Loading state -->
      <div v-if="postStore.loading">Loading slider...</div>
      <!-- Error state -->
      <div v-if="postStore.error">{{ postStore.error }}</div>
      <!-- Success state with slides -->
      <template v-if="!postStore.loading && !postStore.error && postStore.posts.length > 0">
        <swiper-slide-component v-for="post in postStore.posts" :key="post.id">
          <div class="slide-content">
            <p class="postPublish">{{ post.webPage }}</p>
            <img :src="post.pDetailsFileUrl.split(',')[0]" />
            <div class="gradient-overlay"></div>
            <div class="slide-text">
              <!-- <p class="datePost m-0">{{ post.createdDate }}</p> -->
              <h2 v-html="post.priceDetailsTitle"></h2>
              <div style="color:white !important" v-html="post.pDetailsContent" class="description"  :title="post.pDetailsContent"></div>
              <button class="btn moreBtn" @click="redirectToPost(post.id)">{{this.$t("sistemi_prokurorial.slider.button")}}</button>
            </div>
          </div>
        </swiper-slide-component>
        
      </template>
    </swiper-component>
    <!-- No data state -->
    <div v-if="!postStore.loading && !postStore.error && postStore.posts.length === 0">
      No posts available
    </div>
  </div>
</template>
<script>
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Navigation, Pagination, Autoplay   } from 'swiper/modules';
import { usePostsStore } from '@/store/PostStore/postStore';

export default {
  name: 'SwiperExample',  
  data()
  {
    return {
      Navigation,
      Pagination,
      Autoplay,
      postStore: usePostsStore(),
      webPage: '',
      language: 'AL',
      count: 4,
      categoryId: 7,
    };
  },
  created()
  {
    this.fetchPostetSlider();
  },
  methods: {
    fetchPostetSlider()
    {
      const postsData = {
        webPage: this.webPage,
        language: this.language,
        count: this.count,
        categoryId: this.categoryId,
      };
      this.postStore.getPosts(postsData);
    },
    redirectToPost(postId)
    {
      this.$router.push(`/artikulli/${postId}`)
    },
    updatePagination(swiper)
    {
      console.log('Slide changed to:', swiper.activeIndex);
    },
  },
};
</script>


<style scoped>
.slide-content {
  position: relative;
  /* Allows absolute positioning of child elements */
  width: 100%;
  height: 100%;
}

.slide-content img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Ensures the image covers the slide */
}

/* Gradient overlay */
.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  /* Places gradient above the image */
  background: linear-gradient(to right, #000000 0%, #282E37 5%, rgba(0, 0, 0, 0) 70%);
  /* Smooth transition */
  opacity: 0.7;
  /* Controls the transparency of the gradient */
}

.slide-text {
  position: absolute;
  top: 60%;
  left: 20px;
  transform: translateY(-50%);
  color: white;
  font-size: 24px;
  text-align: left;
  padding: 10px;
  max-width: 50%;
  margin-left: 5%;
  margin-right: 5%;
  z-index: 2;
  /* Ensures text is above the gradient */
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.mySwiper {
  height: 500px;
  /* Fixed height for the swiper */
}

.swiper-slide {
  height: 100% !important;
  /* Ensures slides match swiper height */
}

.datePost {
  font-size: 16px;
}

.slide-text h2 {
  font-size: 28px;
  line-height: 30px;
  letter-spacing: -1%;
  color: #FFFF;
  font-weight: 600;
  /* Limit preview rows*/
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.moreBtn {
  padding: 10px 18px;
  background-color: #F5BD2A;
  color: #101828;
  font-weight: 500;
  width: 162px;
}

.postPublish {
  z-index: 2;
  padding: 3px 7px;
  position: absolute;
  background: #F5BD2A;
  font-weight: 600;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-top: 10px;
  font-size: 14px;
  padding-left: 20px !important;
}

.custom-next,
.custom-prev {
  background-color: #F5BD2A;
  color: #101828;
  padding: 10px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.description {
  font-size: 18px;
  line-height: 23px;
  /* Limit preview rows*/
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .swiper-pagination {
  position: absolute !important;
  bottom: 20px !important;
  right: 20px !important;
  width: 120px !important;
  display: flex !important;
  justify-content: flex-end !important;
  transform: rotate(90deg);
  margin-bottom: 85px;
  /* Align right Button control*/
  position: absolute !important;
  position-area: x-start;
  margin-top: 350px;
  margin-right: 30px;
}

::v-deep .swiper-pagination-bullet {
  width: 12px !important;
  height: 12px !important;
  background: #D9D9D9 !important;
  opacity: 0.5 !important;
  border-radius: 2px;
  margin: 0 7px !important;
}

::v-deep .swiper-pagination-bullet-active {
  opacity: 1 !important;
  background: #D9D9D9 !important;
  border-radius: 2px;
  outline-style: solid;
  outline-color: #D9D9D9;
  outline-offset: 4px;
  outline-width: 1px;
}

@media(max-width:767px) {
  .slide-text {
    top: 50%;
    margin-left: 1%;
  }

  .slide-text h2 {
    font-size: 24px;
  }

  ::v-deep .swiper-pagination {
    margin-right: 0px;
  }
}
.description, 
.description * {
  color: white !important;
}
</style>